import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "d38e2c8e-2791-476d-aee6-24a2ceec1909",
    content: "Separate mixes are needed for<br>each potential target playback system.",
    options: {},
  },
  {
    id: "057e3eb1-06f0-4f83-a237-b0be972ad5ad",
    content: "The panning algorithm used by the renderer<br>has no effect on spatial accuracy.",
    options: {},
  },
  {
    id: "9e387821-a6a8-4c3b-8557-61e2f0bb93f0",
    content: "Metadata is an integral<br>component of an audio object.",
    options: {},
  },
  {
    id: "25603336-b3fd-423d-9598-93604190515f",
    content: "Audio objects are rendered to the same<br>positions regardless of the speaker layout.",
    options: {},
  },
  {
    id: "f262aae5-d02d-4061-8202-c4cd040f9cab",
    content: "Allocentric reference preserves spatial<br>relationships between audio objects.",
    options: {},
  },
  {
    id: "afee81d0-3cf1-484c-b36b-92eb5021c373",
    content: "Positional metadata<br>may change dynamically.",
    options: {},
  },
];

export const task: Task = {
  id: "85c97253-8d13-4569-8cec-78473e3d4906",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "9e387821-a6a8-4c3b-8557-61e2f0bb93f0",
    "25603336-b3fd-423d-9598-93604190515f",
    "f262aae5-d02d-4061-8202-c4cd040f9cab",
    "afee81d0-3cf1-484c-b36b-92eb5021c373",
  ],
};
